import { render, staticRenderFns } from "./AccountPopup.vue?vue&type=template&id=f40e4ea4&scoped=true"
import script from "./AccountPopup.vue?vue&type=script&lang=ts"
export * from "./AccountPopup.vue?vue&type=script&lang=ts"
import style0 from "./AccountPopup.vue?vue&type=style&index=0&id=f40e4ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40e4ea4",
  null
  
)

export default component.exports